import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
// import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useAddNewSubFolder(cb, setCountOfFiles, countofFiles) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.REPOSITORY_Directory_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        // SuccessToast({ text: data?.message });

        queryClient.invalidateQueries('repository-folders-sub-folder');
        queryClient.invalidateQueries('repository-folders');

        setCountOfFiles((countofFiles) => ~~countofFiles + 1);

        // cb();
      },
      onError: (error) => {
        // ErrorToast({ text: error.response.data.message });
        cb();
        // setErrorCount(errorCount+1);
      },
    }
  );
}
